<template>
  <section id="slogan">
    <div class="container col-xl-12 col-xxl-12">
    <div class="px-4 py-5 text-center">
      <h3 class="txtSlogan"> Da oltre un decennio al servizio dei passeggeri </h3>
      <div class="trustpilot mt-4">
        <!-- TrustBox widget - Carousel -->
        <div ref="trustbox" class="trustpilot-widget" data-locale="it-IT" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="5c6838a09521140001cbf628" data-style-height="140px" data-style-width="100%" data-theme="light" data-stars="5" data-review-languages="it">
          <a href="https://it.trustpilot.com/review/rimborsoalvolo.it" target="_blank" rel="noopener">Trustpilot</a>
        </div>
        <!-- End TrustBox widget -->
      </div>
    </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TrustPilot",
  mounted() {
    const trustbox = this.$refs.trustbox;
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustbox);
    }
  }
}
</script>

<style scoped>

</style>